<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-form ref="update" @submit.prevent="purchase_update">
        <v-card class="mt-6" elevation="6">
          <div class="pa-3">
            <div class="grid_half">
              <div class="grid_sidebyside">
                <div class="ma-6">
                  <div class="ml-1">เลขที่ใบสั่งซื้อ</div>
                </div>
                <div class="mt-6 mr-1 detail_style">
                  {{ po_data.po_code }}
                </div>
                <div class="ma-6">
                  <div class="ml-1">บริษัท</div>
                </div>
                <div class="mt-6 mr-1 detail_style">
                  {{ po_data.supplier_name }}
                </div>
                <div class="ma-6">
                  <div class="ml-1">แผนก</div>
                </div>
                <div class="mt-6 mr-1 detail_style">
                  <div v-if="po_data.sup_department !== null">{{ po_data.sup_department }}</div>
                  <div v-else>-</div>
                </div>
                <div class="ma-6">
                  <div class="ml-1">การสั่งซื้อ</div>
                </div>
                <div class="mt-3 mr-1">
                  <v-radio-group v-model="po_data.po_type" mandatory>
                    <div class="d-flex justify-space-around">
                      <div class="d-flex">
                        <div>
                          <v-radio color="#86bc3a" :value="0"></v-radio>
                        </div>
                        <div>เงินสด</div>
                      </div>
                      <div class="d-flex">
                        <div>
                          <v-radio color="#86bc3a" :value="1"></v-radio>
                        </div>
                        <div>เครดิต</div>
                      </div>
                    </div>
                  </v-radio-group>
                </div>

              </div>
              <div>
                <div class="ma-6">
                  <div class="ml-1">ภาษีมูลค่าเพิ่ม</div>
                </div>
                <div class="mt-3 mr-1">
                  <v-radio-group v-model="po_data.type_vat" mandatory>
                    <div class="d-flex justify-space-around">
                      <div class="d-flex ml-5">
                        <div>
                          <v-radio color="#86bc3a" :value="0"></v-radio>
                        </div>
                        <div>ภาษีรวมใน</div>
                      </div>
                      <div class="d-flex">
                        <div>
                          <v-radio color="#86bc3a" :value="1"></v-radio>
                        </div>
                        <div>ภาษีแยกนอก</div>
                      </div>
                    </div>
                    <div class="d-flex justify-space-around mt-6">
                      <div class="d-flex" style="margin-left: 3px">
                        <div>
                          <v-radio color="#86bc3a" :value="2"></v-radio>
                        </div>
                        <div>ไม่กระทบภาษี</div>
                      </div>
                      <div class="d-flex ml-n12">
                        <div>
                          <v-radio color="#86bc3a" :value="3"></v-radio>
                        </div>
                        <div>ภาษีเป็น 0</div>
                      </div>
                    </div>
                  </v-radio-group>
                </div>
              </div>
            </div><br>
            <v-divider></v-divider>
            <div class="pa-4 d-flex justify-space-between align-center">
              <span style="font-size: 24px">รายการสินค้า</span>
              <v-btn
                large
                class="grad-success-bg white--text"
                @click="openStockPage"
                title="ดูสต๊อกสินค้า (เปิดแท็บใหม่)"
              >
                <v-icon left>mdi-chart-line</v-icon>
                ดูสต๊อกสินค้า
              </v-btn>
            </div>
            <div class="pa-4">
              <v-autocomplete color="#86bc3a" :items="getProduct" item-text="name" item-value="id"
                @input="addPurchase(id_product)" v-model="id_product" label="ค้นหาสินค้าเพิ่มในใบสั่งซื้อ"
                prepend-inner-icon="mdi-archive" hide-details="auto" outlined></v-autocomplete>
            </div>
            <div class="pa-2">
              <v-card-title>
                <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line
                  hide-details></v-text-field>
              </v-card-title>
              <v-data-table :headers="Headers" :items="po_list" :search="search" key="index" mobile-breakpoint="0"
                hide-default-footer :items-per-page="100">
                <template v-slot:item="dataDetail">
                  <tr>
                    <td>{{ dataDetail.index + 1 }}</td>
                    <td>{{ dataDetail.item.product_code }}</td>
                    <td>{{ dataDetail.item.product_name }}</td>
                    <td class="pa-3">
                      <v-btn small height="42" @click="getHistory(dataDetail.item)"
                        class="grad-success-bg white--text mb-1">
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                    </td>
                    <td class="pa-3">
                      <v-btn small height="42" @click="getStock(dataDetail.item)"
                        class="grad-success-bg white--text mb-1">
                        <v-icon>mdi-warehouse</v-icon>
                      </v-btn>
                    </td>

                    <td>
                      <v-select color="#86bc3a" class="input_width" :items="dataDetail.item.units" item-text="unit_name"
                        item-value="unit_id" v-model="dataDetail.item.unit_id" label="หน่วยนับ" hide-details="auto"
                        outlined @change="updatePriceFromUnit(dataDetail.item)"></v-select>
                    </td>
                    <td>
                      <div class="ma-3 ml-1 ">
                        <v-text-field
                          color="#86bc3a"
                          type="number"
                          @keypress="isOnlyNumber($event)"
                          :rules="[v => !!v && v > 0 && v > '0' || 'กรุณากรอกจำนวนและต้องมากกว่า 0']"
                          min="0"
                          label="จำนวน"
                          hide-details="auto"
                          v-model="dataDetail.item.amount"
                          outlined
                        ></v-text-field>
                      </div>
                    </td>
                    <td>
                      <div class="ma-3 ml-1">
                        <v-text-field color="#86bc3a" type="number"
                          @keypress="isCurrency($event, dataDetail.item.price)" min="0"
                          :rules="v => !!v && v > 0 && v > '0' || 'กรุณากรอกราคาและต้องมากกว่า 0'" label="ราคา"
                          hide-details="auto" v-model="dataDetail.item.price" outlined></v-text-field>
                      </div>
                    </td>
                    <td>
                      <div class="ma-3 ml-1">
                        <v-text-field color="#86bc3a" type="number"
                          @keypress="isCurrency($event, dataDetail.item.discount_unit)" min="0" label="ส่วนลด(บาท)"
                          hide-details="auto" v-model="dataDetail.item.discount_unit" outlined></v-text-field>
                      </div>
                    </td>
                    <td>
                      <div class="ma-3 ml-1">
                        <v-text-field color="#86bc3a" type="number"
                          @keypress="isCurrency($event, dataDetail.item.discount)" min="0" label="ส่วนลด(%)"
                          hide-details="auto" v-model="dataDetail.item.discount" outlined></v-text-field>
                      </div>
                    </td>
                    <td>
                      {{ format_price(
                        dataDetail.item.total = (
                          ((dataDetail.item.price) -
                            ((dataDetail.item.price * dataDetail.item.discount) / 100)
                          ) * dataDetail.item.amount
                        ) - dataDetail.item.discount_unit
                      ) }}
                    </td>
                    <td>
                      <v-btn small height="42" class="grad-danger-bg white--text mb-1"
                        @click="delete_array(dataDetail.item);">
                        <v-icon>mdi-delete-empty-outline</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
                <template v-slot:body.append>
                  <tr class="total_color">
                    <td colspan="7" class="border_col"></td>
                    <td colspan="1" class="pa-2 border_col">
                      <div class="ma-4">
                        <div class="text_total">ยอดรวมสินค้า</div>
                      </div>
                    </td>
                    <td colspan="2" class="pa-2 border_col">
                      <div class="ma-4">
                        <div class="text-center">{{ sub_total }}</div>
                      </div>
                    </td>
                  </tr>
                  <tr class="discount_color">
                    <td colspan="7" class="border_col"></td>
                    <td colspan="1" class="pa-2 border_col">
                      <div class=" ma-4">
                        <div class="text_total">ส่วนลด %</div>
                      </div>
                    </td>
                    <td colspan="2" class="pa-2 border_col">
                      <div class="ma-4">
                        <div>
                          <v-text-field color="#86bc3a" label="ส่วนลด %" append-icon="mdi-percent-outline" type="number"
                            @keypress="isCurrency($event, po_data.discount_percent)" v-model="po_data.discount_percent"
                            hide-details="auto" min="0" max="100" outlined></v-text-field>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr class="discount_color">
                    <td colspan="7" class="border_col"></td>
                    <td colspan="1" class="pa-2 border_col">
                      <div class=" ma-4">
                        <div class="text_total">ส่วนลด(หน่วย)</div>
                      </div>
                    </td>
                    <td colspan="2" class="pa-2 border_col">
                      <div class="ma-4">
                        <div>
                          <v-text-field v-if="po_data.discount_unit != null" color="#86bc3a" label="ส่วนลด(หน่วย)"
                            append-icon="mdi-cash-100" type="number"
                            @keypress="isCurrency($event, po_data.discount_unit)" v-model="po_data.discount_unit"
                            hide-details="auto" min="0" max="100" outlined></v-text-field>
                          <v-text-field v-if="po_data.discount_unit == null" color="#86bc3a" label="ส่วนลด(หน่วย)"
                            append-icon="mdi-cash-100" type="number" value="0.00" hide-details="auto" min="0" max="100"
                            outlined></v-text-field>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr class="discount_color">
                    <td colspan="7" class="border_col"></td>
                    <td colspan="1" class="border_col">
                      <div class="ml-2 mb-7 text_total">มูลค่าสินค่า</div>
                      <div class="ml-2 pt-1 text_total">ภาษีมูลค่าเพิ่ม 7.00%</div>
                    </td>
                    <td colspan="2" class="pa-2 border_col">
                      <div class="ma-4 text-center">{{ po_data.total_no_vat = no_vat }}</div>
                      <v-divider />
                      <div class="ma-4 text-center">{{ po_data.include_vat = cal_vat }}</div>
                    </td>
                  </tr>
                  <tr class="total_color">
                    <td colspan="7" class="border_col"></td>
                    <td colspan="1" class="pa-2 border_col">
                      <div class="ma-4">
                        <div class="text_total">รวมเงินทั้งสิ้น</div>
                      </div>
                    </td>
                    <td colspan="2" class="pa-2 border_col">
                      <div class="ma-4">
                        <div class="text-center">{{ po_data.total_grand = total_all }}</div>
                      </div>
                    </td>
                  </tr>
                  <v-divider />
                </template>
              </v-data-table>
              <div class="pa-4">
                <div class="mb-4">
                  หมายเหตุ
                </div>
                <v-textarea v-if="po_data.note != null" color="#86bc3a" label="กรุณากรอกหมายเหตุ" v-model="po_data.note"
                  outlined></v-textarea>
                <v-textarea v-if="po_data.note == null" color="#86bc3a" label="กรุณากรอกหมายเหตุ" value="-"
                  v-model="po_data.note" outlined></v-textarea>
              </div>
            </div>
          </div>
        </v-card>

        <div class="mt-2 pa-4 text-right">
          <!--        <v-btn x-large class="grad-warning-bg white&#45;&#45;text" style="font-size: 18px" >ดูตัวอย่าง</v-btn>-->
          <!-- <v-btn style="font-size: 18px" x-large
            v-if="po_data.status_approve == 0 && $store.state.status === 1 && po_data.status === 0"
            @click="confirmApprove" class="mr-2 grad-success-bg white--text btn_mobile" title="อนุมัติ">
            <v-icon left>mdi-check-decagram-outline</v-icon>
            อนุมัติ
          </v-btn> -->

          <v-btn v-if="po_data.status_approve == 0 && $store.state.status === 1 && po_data.status === 0" x-large
            :loading="loading_page" :disabled="loading_page" class="grad-warning-bg white--text btn_mobile mr-2"
            style="font-size: 18px" @click="confirmApprove" title="บันทึกและอนุมัติ">
            <v-icon left>mdi-check-decagram-outline</v-icon>
            อนุมัติ พร้อมแก้ไขรายการใบสั่งซื้อ
          </v-btn>
          <div v-else style="color:#8cc63e">อนุมัติแล้ว</div>
          
          <!--        <v-btn x-large class="grad-warning-bg white&#45;&#45;text" style="font-size: 18px" >ดูตัวอย่าง</v-btn>-->
          <v-btn x-large type="submit" class="grad-success-bg white--text btn_mobile"
            style="font-size: 18px">แก้ไขรายการใบสั่งซื้อ</v-btn>
        

        </div>
      </v-form>

      <v-dialog v-model="product_history" max-width="1000">
        <v-card>
          <v-card-title>ประวัติการสั่งซื้อสินค้า</v-card-title>
          <v-card-text>
            <v-data-table :headers="history_headers" :items="history_list" class="elevation-1" disable-sort>
              <template v-slot:item="dataDetails">
                <tr>
                  <td>{{ dataDetails.item.receipt_date }}</td>
                  <td>{{ dataDetails.item.supplier_name }}</td>
                  <td>{{ dataDetails.item.quantity }}</td>
                  <td>{{ dataDetails.item.unit_name }}</td>
                  <td>{{ dataDetails.item.price }}</td>
                  <td>{{ dataDetails.item.cost }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="grad-warning-bg white--text" @click="product_history = false">ปิด</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="product_stock" max-width="1000">
        <v-card>
          <v-card-title>
            <span v-if="selected_product">
              สต๊อกสินค้า - {{ selected_product.product_code }} - {{ selected_product.product_name }}
            </span>
          </v-card-title>

          <!-- เลือกช่วงวันที่สำหรับดูจำนวนเพิ่ม/ลด -->
          <v-card-text class="pt-0">
            <v-row>
              <v-col cols="12" md="5">
                <v-menu
                  v-model="single_start_menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="single_start_date"
                      label="วันที่เริ่มต้น"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      color="#86bc3a"
                      hide-details="auto"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="single_start_date"
                    @input="single_start_menu = false"
                    color="#86bc3a"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="5">
                <v-menu
                  v-model="single_end_menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="single_end_date"
                      label="วันที่สิ้นสุด"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      color="#86bc3a"
                      hide-details="auto"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="single_end_date"
                    @input="single_end_menu = false"
                    color="#86bc3a"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="2" class="d-flex align-end">
                <v-btn
                  block
                  class="grad-success-bg white--text"
                  :loading="loading_single_stock"
                  :disabled="loading_single_stock"
                  @click="fetchSingleProductStock"
                >
                  ค้นหา
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>

          <!-- ใช้ v-data-table เดิม แต่ซ่อน header แล้วเรนเดอร์แถวเอง -->
          <v-data-table :items="tableRows" :headers="[{ text: '', value: 'c1' }, { text: '', value: 'c2' }]"
            hide-default-header hide-default-footer class="elevation-1">
            <template v-slot:item="{ item }">
              <!-- หัวตารางส่วนคลังหลัก -->
            <tr v-if="item.type === 'main_header'">
                <td class="text-center" :style="rowStyle">ชื่อคลัง</td>
                <td class="text-center" :style="rowStyle">จำนวนเพิ่ม</td>
                <td class="text-center" :style="rowStyle">จำนวนลด</td>
                <td class="text-center" :style="rowStyle">สต๊อกคงเหลือ</td>
              </tr>

              <!-- แถวข้อมูลคลังหลัก -->
              <tr v-else-if="item.type === 'main'">
                <td>{{ item.name }}</td>
                <td class="text-center">{{ item.add }}</td>
                <td class="text-center">{{ item.reduce }}</td>
                <td class="text-center">{{ item.qty }}</td>
              </tr>

              <!-- หัวตารางส่วนสาขา -->
              <tr v-else-if="item.type === 'branch_header'">
                <td class="text-center" :style="rowStyle">ชื่อสาขา</td>
                <td class="text-center" :style="rowStyle">จำนวนเพิ่ม</td>
                <td class="text-center" :style="rowStyle">จำนวนลด</td>
                <td class="text-center" :style="rowStyle">สต๊อกคงเหลือ</td>
              </tr>

              <!-- แถวข้อมูลสาขา -->
            <tr v-else>
              <td>{{ item.name }}</td>
              <td class="text-center">{{ item.add }}</td>
              <td class="text-center">{{ item.reduce }}</td>
              <td class="text-center">{{ item.qty }}</td>
              </tr>
            </template>
          </v-data-table>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="grad-warning-bg white--text" @click="product_stock = false">ปิด</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialog สำหรับดูสต๊อกสินค้าหลายตัว -->
      <v-dialog v-model="product_stock_dialog" max-width="900" persistent>
        <v-card>
          <v-card-title class=" py-2">
            <span>ดูสต๊อกสินค้า</span>
          </v-card-title>
          <v-card-text class="pt-2">
            <v-row class="mb-2">
              <v-col cols="12">
                <v-autocomplete
                  v-model="selected_products_stock"
                  :items="getProduct"
                  item-text="name"
                  item-value="id"
                  label="เลือกสินค้า"
                  color="#86bc3a"
                  multiple
                  chips
                  deletable-chips
                  prepend-inner-icon="mdi-package-variant"
                  outlined
                  dense
                  small-chips
                  hide-details="auto"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row class="mb-2">
              <v-col cols="12" md="4">
                <v-select
                  v-model="selected_branch_stock"
                  :items="branches_stock"
                  item-text="name"
                  item-value="id"
                  label="เลือกสาขา"
                  color="#86bc3a"
                  outlined
                  dense
                  hide-details="auto"
                  clearable
                  prepend-inner-icon="mdi-store"
                ></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-menu
                  v-model="start_date_menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="start_date_stock"
                      label="วันที่เริ่มต้น *"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      color="#86bc3a"
                      outlined
                      dense
                      hide-details="auto"
                      :rules="[v => !!v || 'กรุณาเลือกวันที่เริ่มต้น']"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="start_date_stock"
                    @input="start_date_menu = false"
                    color="#86bc3a"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="4">
                <v-menu
                  v-model="end_date_menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="end_date_stock"
                      label="วันที่สิ้นสุด *"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      color="#86bc3a"
                      outlined
                      dense
                      hide-details="auto"
                      :rules="[v => !!v || 'กรุณาเลือกวันที่สิ้นสุด']"
                      :min="start_date_stock"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="end_date_stock"
                    @input="end_date_menu = false"
                    color="#86bc3a"
                    :min="start_date_stock"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row v-if="loading_stock_data" class="mb-4">
              <v-col cols="12" class="text-center">
                <v-progress-circular indeterminate color="#86bc3a"></v-progress-circular>
                <div class="mt-2">กำลังโหลดข้อมูล...</div>
              </v-col>
            </v-row>
            <div v-else-if="stock_data_results.length > 0" class="mt-4">
              <div v-for="(result, index) in stock_data_results" :key="index" class="mb-6">
                <v-card elevation="3" class="mb-4">
                  <v-card-title class="grad-success-bg white--text py-3">
                    <v-icon left color="white">mdi-package-variant</v-icon>
                    {{ getProductName(result.product_id) }}
                  </v-card-title>
                  <v-card-text class="pa-4">
                    <div v-if="result.data && result.data.length > 0">
                      <div v-for="(warehouse, wIndex) in result.data" :key="wIndex" class="mb-4">
                        <v-card outlined class="mb-3" style="border-left: 4px solid #86bc3a;">
                          <v-card-subtitle class="font-weight-bold pa-3" style="background-color: #f5f5f5;">
                            <div class="d-flex align-center">
                              <v-icon :color="warehouse.is_main ? 'green' : 'blue'" class="mr-2" size="24">
                                {{ warehouse.is_main ? 'mdi-warehouse' : 'mdi-store' }}
                              </v-icon>
                              <span class="text-h6">{{ warehouse.warehouse }}</span>
                              <v-chip v-if="warehouse.is_main" small color="green" text-color="white" class="ml-3">
                                คลังหลัก
                              </v-chip>
                            </div>
                          </v-card-subtitle>
                          <v-card-text class="pa-0">
                            <v-data-table
                              v-if="warehouse.data_other && warehouse.data_other.length > 0"
                              :headers="stock_history_headers"
                              :items="warehouse.data_other"
                              hide-default-footer
                              class="elevation-0"
                              dense
                            >
                              <template v-slot:item.quantity="{ item }">
                                <span class="font-weight-medium">{{ formatNumber(item.quantity) }}</span>
                              </template>
                              <template v-slot:item.quantity_reduced="{ item }">
                                <span style="color: #d32f2f; font-weight: 500;">-{{ formatNumber(item.quantity_reduced) }}</span>
                              </template>
                              <template v-slot:item.quantity_added="{ item }">
                                <span style="color: #388e3c; font-weight: 500;">+{{ formatNumber(item.quantity_added) }}</span>
                              </template>
                              <template v-slot:item.date="{ item }">
                                <span class="font-weight-medium">{{ formatDate(item.date) }}</span>
                              </template>
                            </v-data-table>
                            <div v-else class="pa-4 text-center grey--text">
                              ไม่พบข้อมูลสต๊อกในช่วงวันที่ที่เลือก
                            </div>
                          </v-card-text>
                        </v-card>
                      </div>
                    </div>
                    <div v-else class="pa-4 text-center grey--text">
                      ไม่พบข้อมูลสต๊อกสำหรับสินค้านี้ในช่วงวันที่ที่เลือก
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </div>
            <v-row v-else-if="!loading_stock_data && stock_data_results.length === 0 && has_searched">
              <v-col cols="12" class="text-center">
                <div class="grey--text">ไม่พบข้อมูล</div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="#86bc3a"
              class="white--text"
              @click="fetchProductStock"
              :disabled="!canSearchStock"
              :loading="loading_stock_data"
            >
              <v-icon left>mdi-magnify</v-icon>
              ค้นหา
            </v-btn>
            <v-btn class="grad-warning-bg white--text" @click="closeProductStockDialog">ปิด</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


    </div>
  </div>
</template>

<script>
import { HTTP } from "@/axios";
import Swal from "sweetalert2";
import { formatPrice, onlyForCurrency, onlyForNumber } from "@/js/handler";

export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  name: "Purchase_edit",
  data() {
    return {
      loading_page: false,
      search: null,
      Headers: [
        {
          text: 'ลำดับ',
          value: 'id',
          fixed: true,
          width: '100px',
        },
        {
          text: 'รหัสสินค้า',
          value: 'product_code',
          fixed: true,
          width: '140px',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'product_name',
          fixed: true,
          width: '200px',
        },
        {
          text: 'ประวัติ',
          value: '',
          sortable: false,
          fixed: true,
          width: '100px',
        },
        {
          text: 'สต๊อก',
          value: '',
          sortable: false,
          fixed: true,
          width: '100px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit',
          sortable: false,
          fixed: true,
          width: '150px',
        },
        {
          text: 'จำนวน',
          value: 'count',
          fixed: true,
          width: '170px',
        },
        {
          text: 'ราคา',
          value: 'price',
          fixed: true,
          width: '170px',
        },
        {
          text: 'ส่วนลด(บาท)',
          value: 'discount_unit',
          fixed: true,
          width: '170px',
        },
        {
          text: 'ส่วนลด(%)',
          value: 'discount_percent',
          fixed: true,
          width: '170px',
        },
        {
          text: 'รวม',
          value: 'total',
          fixed: true,
          width: '120px',
        },
        {
          text: 'ลบ',
          value: '',
          sortable: false,
          fixed: true,
          width: '50px',
        },
      ],
      po_list: [],
      unit_list: [],
      po_data: {
        po_code: null,
        supplier_id: null,
        supplier_name: null,
        sup_department: null,
        po_type: null,
        type_vat: null,
        note: null,
        discount_percent: 0,
        discount_unit: 0,
        total_no_vat: null,
        include_vat: null,
        total_grand: null,
      },
      total: 0,
      unit: null,
      loop_id: null,
      pop_value: null,
      id_product: null,
      arr_delete_product: [],
      product_suppliers: [],
      getProduct: [],
      product_lists: [],
      import_product_list: [],
      count_warehouse: null,
      test: [],
      product_history: false,
      product_stock: false,
      history_list: [],
      stock_list: [],
      selected_product: null,
      history_headers: [
        { text: 'วันที่', value: 'receipt_date' },
        { text: 'บริษัท', value: 'supplier_name' },
        { text: 'จำนวน', value: 'quantity' },
        { text: 'หน่วย', value: 'unit_name' },
        { text: 'ราคา', value: 'price' },
        { text: 'ต้นทุน', value: 'cost' },
      ],
      stock_headers: [
        { text: 'ชื่อคลัง', value: 'warehouse' },
        { text: 'สต๊อกคงเหลือ', value: 'quantity' },
      ],
      rowStyle: 'font-size:16px !important; color:#616A6B !important; font-weight: bold;',
      // สำหรับ dialog ดูสต๊อกสินค้าหลายตัว
      product_stock_dialog: false,
      selected_products_stock: [],
      selected_branch_stock: null,
      branches_stock: [],
      start_date_stock: null,
      end_date_stock: null,
      start_date_menu: false,
      end_date_menu: false,
      loading_stock_data: false,
      stock_data_results: [],
      has_searched: false,
      stock_history_headers: [
        { text: 'วันที่', value: 'date', sortable: false },
        { text: 'จำนวนคงเหลือ', value: 'quantity', sortable: false, align: 'right' },
        { text: 'จำนวนที่ลด', value: 'quantity_reduced', sortable: false, align: 'right' },
        { text: 'จำนวนที่เพิ่ม', value: 'quantity_added', sortable: false, align: 'right' },
      ],

      // วันที่สำหรับ popup สต๊อกสินค้าเดี่ยว
      single_start_date: null,
      single_end_date: null,
      single_start_menu: false,
      single_end_menu: false,
      loading_single_stock: false,

    }
  },

  methods: {
    format_price: function (value) {
      return formatPrice(value)
    },
    isOnlyNumber: function (evt) {
      return onlyForNumber(evt)
    },
    isCurrency: function (evt, number) {
      return onlyForCurrency(evt, number)
    },
    async isNumber(evt, number) {
      evt = (evt) ? evt : window.event;
      let charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      }
      // restrict to 2 decimal places
      if (number != null && number.indexOf(".") > -1 && (number.split('.')[1].length > 1)) {
        evt.preventDefault();
      }
      else {
        return true
      }
    },
    getHistory(product) {
      this.selected_product = product;
      this.product_history = true;
      HTTP.post('/purchaseorders/gethistoryimport', {
        product_id: product.product_id
      }).then((res) => {
        if (res.data.success) {
          this.history_list = res.data.object;

        }
      });
    },
    getStock(product) {
      this.selected_product = product;
      this.product_stock = true;
      // ตั้งค่า default ช่วงวันที่ย้อนหลัง 30 วัน ถ้ายังไม่ได้เลือก
      if (!this.single_start_date || !this.single_end_date) {
        const end = new Date();
        const start = new Date();
        start.setDate(end.getDate() - 29);
        const toYMD = d => d.toISOString().slice(0, 10);
        this.single_start_date = toYMD(start);
        this.single_end_date = toYMD(end);
      }
      this.fetchSingleProductStock();
    },
    async fetchSingleProductStock() {
      if (!this.selected_product) return;

      // ถ้ากรอกวันที่ แต่ช่วงวันไม่ถูกต้อง ให้เตือน
      if (this.single_start_date && this.single_end_date &&
          new Date(this.single_start_date) > new Date(this.single_end_date)) {
        Swal.fire({
          title: 'วันที่ไม่ถูกต้อง',
          text: 'วันที่เริ่มต้นต้องน้อยกว่าหรือเท่ากับวันที่สิ้นสุด',
          icon: 'warning',
        });
        return;
      }

      const payload = {
        product_id: this.selected_product.product_id,
        product_code: this.selected_product.product_code,
      };

      if (this.single_start_date && this.single_end_date) {
        payload.start_date = this.single_start_date;
        payload.end_date = this.single_end_date;
      }

      this.loading_single_stock = true;
      try {
        const res = await HTTP.post('/purchaseorders/getproductstock', payload);
        if (res.data.success) {
          this.stock_list = res.data.object || [];
        }
      } catch (e) {
        console.error(e);
        Swal.fire({
          title: 'โหลดข้อมูลสต๊อกไม่สำเร็จ',
          icon: 'error',
        });
      } finally {
        this.loading_single_stock = false;
      }
    },
    getQtyFromUnit(units, unit_id) {
      const found = units.find(u => u.unit_id === unit_id);
      return found ? parseFloat(found.unit_qty) : 1;
    },
    updatePriceFromUnit(item) {
      const selectedUnit = item.units.find(u => u.unit_id === item.unit_id);
      const qty = selectedUnit ? selectedUnit.unit_qty : 1;
      item.price = parseFloat(item.price_base * qty).toFixed(2);
    },
    getProductList() {
      this.loading_page = true
      HTTP.post('/purchaseorders/products')
        .then((res) => {
          if (res.data.success === true) {
            this.loading_page = false
            this.getProduct = res.data.products
          }
        })
    },
    getPO_list() {
      this.loading_page = true
      HTTP.post('/purchaseorders/getpolists', {
        po_id: this.$route.params.id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.po_data.po_code = res.data.object.po.po_code
          this.po_data.sup_department = res.data.object.po.sup_department
          this.po_data.supplier_id = res.data.object.po.supplier_id
          this.po_data.supplier_name = res.data.object.po.supplier_name
          this.po_data.po_type = res.data.object.po.po_type
          this.po_data.type_vat = res.data.object.po.type_vat
          this.po_data.note = res.data.object.po.note
          this.po_data.discount_percent = res.data.object.po.discount_percent
          this.po_data.discount_unit = res.data.object.po.discount
          this.po_data.status = res.data.object.po.status ?? 0;
          this.po_data.status_approve = res.data.object.po.status_approve ?? 0;

          // สร้าง loop_id และ normalize จำนวน (amount / qty) สำหรับสินค้าเก่าถ้ายังไม่มี
          let maxLoopId = 0;
          this.po_list = res.data.object.po_lists.map((item, index) => {
            // คำนวณราคาต่อ 1 หน่วยหลัก (price_base)
            const unitQty = this.getQtyFromUnit(item.units || [], item.unit_id);
            const price_base = unitQty
              ? parseFloat(item.price / unitQty)
              : parseFloat(item.price) || 0;

            // ให้ amount เป็นตัวหลักในการเก็บจำนวน
            const normalizedAmount =
              item.amount !== null && item.amount !== undefined
                ? item.amount
                : (item.qty !== null && item.qty !== undefined ? item.qty : 0);

            // ถ้ายังไม่มี loop_id ให้สร้างใหม่
            const loop_id = item.loop_id || (maxLoopId = Math.max(maxLoopId, index + 1));

            return {
              ...item,
              loop_id,
              amount: normalizedAmount,
              // เก็บ qty ไว้ด้วย ให้เท่ากับ amount เพื่อกันโค้ดส่วนอื่นที่อาจอ้างถึง qty
              qty: normalizedAmount,
              price_base,
            };
          });

          // ตั้งค่า loop_id เริ่มต้นสำหรับสินค้าใหม่
          this.loop_id = this.po_list.length > 0
            ? Math.max(...this.po_list.map(item => item.loop_id || 0))
            : 0;
        }
      })
    },
    async addPurchase(id_product) {
      await HTTP.post('/purchaseorders/getsupsandunits', {
        product_id: id_product
      }).then((res) => {
        if (res.data.success === true) {
          this.product_lists = res.data.product_lists
          this.count_warehouse = res.data.count_warehouse
          this.product_suppliers = res.data.product_suppliers
          if (res.data.import_product_lists !== null) {
            this.import_product_list = res.data.import_product_lists
          } else {
            this.import_product_list = {
              quantity: null,
              cost: null,
              discount_unit: null,
              discount_percent: null,
            }
          }
          let supplier_cut = this.product_suppliers.map((data) => { return data.sup_id })
          this.pop_supplier = supplier_cut.shift()
          let value_cut = this.product_lists.map((data) => { return data.unit_id })
          this.pop_value = value_cut.shift()
        }
      })
      // console.log(this.getProduct, 'product')
      let value = this.getProduct.filter((res) => {
        return res.id == id_product
      });

      value.forEach((details) => {
        const id = this.loop_id += 1;
        this.po_list.push({
          count_warehouse: this.count_warehouse,
          status_credit: true,
          loop_id: id,
          id: null,
          product_id: details.id,
          product_code: details.product_code,
          product_name: details.name,
          qty: this.import_product_list.quantity,
          product_lists: this.product_lists,
          units: this.product_lists,
          unit_id: this.product_lists[0].unit_id,
          product_suppliers: this.product_suppliers,
          supplier: this.pop_supplier,
          supplier_name: null,
          amount: this.import_product_list.quantity,
          price: this.import_product_list.cost,
          discount_unit: parseFloat(this.import_product_list.discount_unit == null || this.import_product_list.discount_unit == '' ? '0.00' : this.import_product_list.discount_unit),
          discount: parseFloat(this.import_product_list.discount_percent == null || this.import_product_list.discount_percent == '' ? '0.00' : this.import_product_list.discount_percent),
          total: 0,
          type_vat: 1,
          type_purchase: 1,
          show_input: 0,
        })
      })

      await this.$nextTick(() => {
        this.id_product = null;
        this.alert_success = true;
        setTimeout(() => this.alert_success = false, 2000);
      })
    },
    purchase_update() {
      this.test = this.po_list
      if (this.$refs.update.validate()) {
        // แก้ไข po_lists ให้ qty = amount สำหรับทุกตัว (เพื่อให้ controller ใช้ qty สำหรับสินค้าเก่าได้)
        const po_lists_to_send = this.po_list.map(item => ({
          ...item,
          qty: item.amount !== null && item.amount !== undefined ? item.amount : (item.qty || 0),
        }));

        HTTP.post('/purchaseorders/updatepo', {
          po_id: this.$route.params.id,
          po_code: this.po_data.po_code,
          supplier_id: this.po_data.supplier_id,
          po_type: this.po_data.po_type,
          type_vat: this.po_data.type_vat,
          discount_percent: this.po_data.discount_percent,
          discount_unit: this.po_data.discount_unit,
          total_no_vat: parseFloat(this.po_data.total_no_vat.replace(/,/g, '')),
          include_vat: parseFloat(this.po_data.include_vat.replace(/,/g, '')),
          total_grand: parseFloat(this.po_data.total_grand.replace(/,/g, '')),
          note: this.po_data.note,
          po_lists: po_lists_to_send,
          arr_delete_product: this.arr_delete_product,
        }).then((res) => {
          if (res.data.success === true) {
            Swal.fire({
              title: 'บันทึกข้อมูลเรียบร้อย !',
              icon: 'success',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            }).then(() => {
              this.$router.push('/purchase')
            })
          }
        })
      }
    },
    get_units() {
      HTTP.get('/products/units/all')
        .then((res) => {
          if (res.data.success === true) {
            this.unit_list = res.data.object
          }
        })
    },
    delete_array(item) {
      // ถ้าเป็นสินค้าเก่าที่มี id ให้เก็บ id ไว้เพื่อลบใน database
      if (item.id !== null && item.id !== undefined) {
        this.arr_delete_product.push(item.id);
      }
      
      // หา index ของ item ที่ต้องการลบโดยใช้ loop_id หรือ id
      let itemIndex = -1;
      if (item.loop_id !== null && item.loop_id !== undefined) {
        // สำหรับสินค้าใหม่ ใช้ loop_id
        itemIndex = this.po_list.findIndex(listItem => listItem.loop_id === item.loop_id);
      } else if (item.id !== null && item.id !== undefined) {
        // สำหรับสินค้าเก่า ใช้ id
        itemIndex = this.po_list.findIndex(listItem => listItem.id === item.id);
      }

      if (itemIndex !== -1) {
        // ลบ item จาก array
        this.po_list.splice(itemIndex, 1);
      }
    },
    async confirmApprove() {
      const { isConfirmed } = await Swal.fire({
        title: 'ยืนยันบันทึกและอนุมัติ?',
        text: 'ต้องการบันทึกการแก้ไขและอนุมัติใบสั่งซื้อนี้หรือไม่\nเมื่ออนุมัติแล้วจะไม่สามารถแก้ไขได้',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        confirmButtonColor: '#88b742'
      });
      if (!isConfirmed) return;

      // ตรวจ validation ของฟอร์มก่อน
      const valid = this.$refs.update?.validate?.();
      if (!valid) {
        Swal.fire({
          title: 'กรอกข้อมูลไม่ครบ',
          text: 'กรุณาตรวจสอบจำนวน/ราคา/ส่วนลด ให้ถูกต้อง',
          icon: 'warning'
        });
        return;
      }

      try {
        this.loading_page = true;

        // แก้ไข po_lists ให้ qty = amount สำหรับทุกตัว (เพื่อให้ controller ใช้ qty สำหรับสินค้าเก่าได้)
        const po_lists_to_send = this.po_list.map(item => ({
          ...item,
          qty: item.amount !== null && item.amount !== undefined ? item.amount : (item.qty || 0),
        }));

        // 1) บันทึกการแก้ไข
        await HTTP.post('/purchaseorders/updatepo', {
          po_id: this.$route.params.id,
          po_code: this.po_data.po_code,
          supplier_id: this.po_data.supplier_id,
          po_type: this.po_data.po_type,
          type_vat: this.po_data.type_vat,
          discount_percent: this.po_data.discount_percent,
          discount_unit: this.po_data.discount_unit,
          total_no_vat: parseFloat(this.po_data.total_no_vat.replace(/,/g, '')),
          include_vat: parseFloat(this.po_data.include_vat.replace(/,/g, '')),
          total_grand: parseFloat(this.po_data.total_grand.replace(/,/g, '')),
          note: this.po_data.note,
          po_lists: po_lists_to_send,
          arr_delete_product: this.arr_delete_product,
        });

        // 2) อนุมัติ
        await HTTP.get('/purchaseorders/approve/' + this.$route.params.id);

        await Swal.fire({
          title: 'บันทึกและอนุมัติสำเร็จ',
          icon: 'success',
          timer: 1200,
          showConfirmButton: false
        });

        // 3) กลับหน้ารายการซื้อ
        this.$router.push('/purchase');
      } catch (e) {
        Swal.fire({
          title: 'ไม่สำเร็จ',
          text: 'เกิดข้อผิดพลาดระหว่างบันทึกหรืออนุมัติ',
          icon: 'error'
        });
      } finally {
        this.loading_page = false;
      }
    }

    ,

    order_approved(id) {
      this.loading_page = true;
      HTTP.get('/purchaseorders/approve/' + id)
        .then((res) => {
          if (res.data?.success === true) {
            Swal.fire({
              title: 'อนุมัติสำเร็จ',
              icon: 'success',
              timer: 1200,
              showConfirmButton: false
            }).then(() => {
              this.$router.push('/purchase');   // ⟵ ไปหน้ารายการซื้อ
            });
          } else {
            Swal.fire({
              title: 'อนุมัติไม่สำเร็จ',
              text: res.data?.message || 'โปรดลองอีกครั้ง',
              icon: 'error'
            });
          }
        })
        .catch(() => {
          Swal.fire({
            title: 'เกิดข้อผิดพลาด',
            text: 'ไม่สามารถอนุมัติได้ในขณะนี้',
            icon: 'error'
          });
        })
        .finally(() => {
          this.loading_page = false;
        });
    },
    openProductStockDialog() {
      this.product_stock_dialog = true;
      this.selected_products_stock = [];
      this.selected_branch_stock = null;
      this.start_date_stock = null;
      this.end_date_stock = null;
      this.stock_data_results = [];
      this.has_searched = false;
      if (this.branches_stock.length === 0) {
        this.fetchBranchesStock();
      }
    },
    openStockPage() {
      const route = this.$router.resolve({ name: 'purchasestock' });
      window.open(route.href, '_blank');
    },
    closeProductStockDialog() {
      this.product_stock_dialog = false;
      this.selected_products_stock = [];
      this.selected_branch_stock = null;
      this.start_date_stock = null;
      this.end_date_stock = null;
      this.stock_data_results = [];
      this.has_searched = false;
    },
    async fetchBranchesStock() {
      try {
        const response = await HTTP.get('/sales-history/branches');
        if (response.data.success) {
          this.branches_stock = response.data.data || [];
        }
      } catch (error) {
        console.error('Error fetching branches:', error);
        // ถ้า API นี้ไม่มี อาจจะลองใช้ API อื่นหรือไม่แสดง error
      }
    },
    async fetchProductStock() {
      if (!this.start_date_stock || !this.end_date_stock) {
        Swal.fire({
          title: 'กรุณาเลือกวันที่',
          text: 'กรุณาเลือกวันที่เริ่มต้นและวันที่สิ้นสุด',
          icon: 'warning'
        });
        return;
      }

      if (this.selected_products_stock.length === 0) {
        Swal.fire({
          title: 'กรุณาเลือกสินค้า',
          text: 'กรุณาเลือกสินค้าอย่างน้อย 1 รายการ',
          icon: 'warning'
        });
        return;
      }

      if (new Date(this.start_date_stock) > new Date(this.end_date_stock)) {
        Swal.fire({
          title: 'วันที่ไม่ถูกต้อง',
          text: 'วันที่เริ่มต้นต้องน้อยกว่าหรือเท่ากับวันที่สิ้นสุด',
          icon: 'warning'
        });
        return;
      }

      this.loading_stock_data = true;
      this.has_searched = true;
      this.stock_data_results = [];

      try {
        // สร้าง array ของ products ที่เลือก
        const products = this.selected_products_stock
          .map(productId => {
            const product = this.getProduct.find(p => p.id === productId);
            return product ? {
              product_id: productId,
              product_code: product.product_code
            } : null;
          })
          .filter(p => p !== null);

        if (products.length === 0) {
          Swal.fire({
            title: 'เกิดข้อผิดพลาด',
            text: 'ไม่พบข้อมูลสินค้าที่เลือก',
            icon: 'error'
          });
          this.loading_stock_data = false;
          return;
        }

        // สร้าง request payload
        const requestData = {
          products: products,
          start_date: this.start_date_stock,
          end_date: this.end_date_stock
        };
        
        // เพิ่ม branch_id ถ้ามีการเลือกสาขา
        if (this.selected_branch_stock) {
          requestData.branch_id = this.selected_branch_stock;
        }

        // ยิง API เพียงครั้งเดียว (ใช้ API ใหม่สำหรับ dialog ดูสต๊อกสินค้า)
        const response = await HTTP.post('/purchaseorders/getproductsstockhistory', requestData);

        if (response.data.success) {
          // รับ response ที่เป็น array ของผลลัพธ์สำหรับสินค้าหลายตัว
          // Response structure: [{ product_id, product_code, warehouses: [{ warehouse, is_main, data_other: [...] }] }]
          const responseData = response.data.object || [];
          
          console.log('API Response Data:', responseData);
          
          // แปลง response ให้เป็นรูปแบบที่ต้องการ
          this.stock_data_results = products.map((product) => {
            const productId = product.product_id;
            const productInfo = this.getProduct.find(p => p.id === productId);
            
            // หา response data สำหรับ product นี้
            let item = responseData.find(r => 
              r.product_id === productId || 
              r.product_code === product.product_code
            );
            
            if (!item) {
              console.log(`No item found for product_id: ${productId}, product_code: ${product.product_code}`);
              return null;
            }
            
            console.log(`Found item for product_id: ${productId}:`, item);
            
            // ดึง warehouse data จาก warehouses array
            let warehouseData = item.warehouses || [];
            
            console.log(`Warehouse data for product_id: ${productId}:`, warehouseData);
            
            // กรองข้อมูลตามสาขาที่เลือก (ถ้ามีการเลือก)
            if (this.selected_branch_stock && Array.isArray(warehouseData) && warehouseData.length > 0) {
              const selectedBranch = this.branches_stock.find(b => b.id === this.selected_branch_stock);
              if (selectedBranch) {
                warehouseData = warehouseData.filter(w => 
                  w.warehouse === selectedBranch.name || 
                  w.warehouse === selectedBranch.branch_name ||
                  (w.warehouse && w.warehouse.includes(selectedBranch.name))
                );
                console.log(`Filtered warehouse data for product_id: ${productId}:`, warehouseData);
              }
            }
            
            return {
              product_id: productId,
              product_code: product.product_code,
              product_name: productInfo?.name || '',
              data: Array.isArray(warehouseData) ? warehouseData : []
            };
          }).filter(r => r !== null && r !== undefined);
          
          console.log('Final stock_data_results:', this.stock_data_results);
        } else {
          Swal.fire({
            title: 'เกิดข้อผิดพลาด',
            text: response.data.message || 'ไม่สามารถโหลดข้อมูลได้',
            icon: 'error'
          });
        }
      } catch (error) {
        console.error('Error fetching product stock:', error);
        Swal.fire({
          title: 'เกิดข้อผิดพลาด',
          text: 'ไม่สามารถโหลดข้อมูลได้',
          icon: 'error'
        });
      } finally {
        this.loading_stock_data = false;
      }
    },
    getProductName(productId) {
      const product = this.getProduct.find(p => p.id === productId);
      return product ? `${product.product_code} - ${product.name}` : `Product ID: ${productId}`;
    },
    formatNumber(value) {
      if (value == null || value === '') return '0.00';
      const num = parseFloat(value);
      return isNaN(num) ? value : num.toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    formatDate(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },

  },
  computed: {
    canSearchStock() {
      return this.selected_products_stock.length > 0 && 
             this.start_date_stock && 
             this.end_date_stock &&
             new Date(this.start_date_stock) <= new Date(this.end_date_stock);
    },
    tableRows() {
      // stock_list มาจาก API รูปแบบ: [{ warehouse, quantity, quantity_added, quantity_reduced, is_main }, ...]
      const isMain = r => r.is_main === true || (r.warehouse || '').includes('คลังหลัก');
      const main = this.stock_list.find(isMain) || { warehouse: 'คลังหลัก', quantity: 0, quantity_added: 0, quantity_reduced: 0 };
      const branches = this.stock_list.filter(r => !isMain(r));

      return [
        { type: 'main_header' },
        { type: 'main', name: main.warehouse, qty: main.quantity, add: main.quantity_added || 0, reduce: main.quantity_reduced || 0 },
        { type: 'branch_header' },
        ...branches.map(b => ({
          type: 'branch',
          name: b.warehouse,
          qty: b.quantity,
          add: b.quantity_added || 0,
          reduce: b.quantity_reduced || 0
        }))
      ];
    },
    sub_total() {
      // let data_list = this.po_list;
      // const result = data_list.reduce((sum,number) => {
      //   let total_all = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //   if (total_all < 0) {
      //     return sum + 0;
      //   }
      //   else {
      //     return sum + total_all;
      //   }
      // }, 0)
      // return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      let data_list = this.po_list;
      const result = data_list.reduce((sum, number) => {
        return sum + number.total
      }, 0);
      return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    no_vat() {
      // let discount_percent = this.po_data.discount_percent;
      // let discount_unit = this.po_data.discount_unit;
      // let data_list = this.po_list;
      // const result = data_list.reduce((sum,number) => {
      //   if (this.po_data.type_vat == 0){
      //     let total_all = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //     let dis_percent = ((total_all * discount_percent) / 100)
      //     let total_final = total_all - dis_percent
      //     let total_grand = total_final - discount_unit
      //     let in_vat = ((total_all * 7)/107);
      //     let total = total_grand - in_vat
      //     if (total < 0) {
      //       return sum + 0;
      //     }
      //     else {
      //       return sum + total;
      //     }
      //   }
      //   else if(this.po_data.type_vat == 1) {
      //     let total_all = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //     let dis_percent = ((total_all * discount_percent) / 100)
      //     let total_final = total_all - dis_percent
      //     let total_grand = total_final - discount_unit
      //     if (total_grand < 0) {
      //       return sum + 0;
      //     }
      //     else {
      //       return sum + total_grand;
      //     }
      //   }
      //   else if(this.po_data.type_vat == 2) {
      //     let total_all = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //     let dis_percent = ((total_all * discount_percent) / 100)
      //     let total_final = total_all - dis_percent
      //     let total_grand = total_final - discount_unit
      //     if (total_grand < 0) {
      //       return sum + 0;
      //     }
      //     else {
      //       return sum + total_grand;
      //     }
      //   }
      //   else if(this.po_data.type_vat == 3) {
      //     let total_all = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //     let dis_percent = ((total_all * discount_percent) / 100)
      //     let total_final = total_all - dis_percent
      //     let total_grand = total_final - discount_unit
      //     if (total_grand < 0) {
      //       return sum + 0;
      //     }
      //     else {
      //       return sum + total_grand;
      //     }
      //   }
      // }, 0)
      // return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");


      let discount_percent = this.po_data.discount_percent;
      let discount_unit = this.po_data.discount_unit;
      let data_list = this.po_list;
      const subTotal = data_list.reduce((sum, number) => {
        return sum + number.total;
      }, 0);

      let percent = (parseFloat(subTotal) * discount_percent) / 100;
      let total_percent = parseFloat(subTotal) - percent;
      let total_discount = total_percent - discount_unit;

      if (this.po_data.type_vat == 0) {
        let before_vat = total_discount * (100 / 107);
        return before_vat.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return total_discount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    cal_vat() {
      // let data_list = this.po_list;
      // const result = data_list.reduce((sum,number) => {
      //   if (this.po_data.type_vat == 0) {
      //     let total_all = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //     let calculate = ((total_all * 7)/107);
      //     return sum + (calculate);
      //   }
      //   else if (this.po_data.type_vat == 1){
      //     let total_all = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //     let calculate = (total_all * (7 / 100));
      //     return sum + (calculate);
      //   }
      //   else if (this.po_data.type_vat == 2) {
      //     let calculate = 0;
      //     return sum + (calculate);
      //   }
      //   else if (this.po_data.type_vat == 3) {
      //     let calculate = 0;
      //     return sum + (calculate);
      //   }
      // }, 0)
      // return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");


      let discount_percent = this.po_data.discount_percent;
      let discount_unit = this.po_data.discount_unit;
      let data_list = this.po_list;
      const subTotal = data_list.reduce((sum, number) => {
        return sum + number.total;
      }, 0);

      let percent = (parseFloat(subTotal) * discount_percent) / 100;
      let total_percent = parseFloat(subTotal) - percent;
      let total_discount = total_percent - discount_unit;

      if (this.po_data.type_vat == 0) {
        let result_vat = total_discount * (7 / 107);
        return result_vat.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else if (this.po_data.type_vat == 1) {
        let result_vat = total_discount * (7 / 100);
        return result_vat.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        let zero = 0
        return zero.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    total_all() {
      // let discount_percent = this.po_data.discount_percent;
      // let discount_unit = this.po_data.discount_unit;
      // let data_list = this.po_list;
      // const result = data_list.reduce((sum,number) => {
      //   if (this.po_data.type_vat == 0){
      //     let total_all = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //     let dis_percent = ((total_all * discount_percent) / 100)
      //     let total_final = total_all - dis_percent
      //     let total_grand = total_final - discount_unit
      //     if (total_grand < 0) {
      //       return sum + 0;
      //     }
      //     else {
      //       return sum + total_grand;
      //     }
      //   }
      //   else if (this.po_data.type_vat == 1){
      //     let total = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //     let dis_percent = ((total * discount_percent) / 100)
      //     let total_final = total - dis_percent
      //     let total_grand = total_final - discount_unit
      //     let ex_vat = ((total) * (7/100))
      //     let total_all = total_grand + ex_vat
      //     if (total_all < 0) {
      //       return sum + 0;
      //     }
      //     else {
      //       return sum + (total_all);
      //     }
      //   }
      //   else if (this.po_data.type_vat == 2){
      //     let total = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //     let dis_percent = ((total * discount_percent) / 100)
      //     let total_final = total - dis_percent
      //     let total_grand = total_final - discount_unit
      //     if (total_grand < 0) {
      //       return sum + 0;
      //     }
      //     else {
      //       return sum + (total_grand)
      //     }
      //   }
      //   else if (this.po_data.type_vat == 3){
      //     let total = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty) - number.discount_unit;
      //     let dis_percent = ((total * discount_percent) / 100)
      //     let total_final = total - dis_percent
      //     let total_grand = total_final - discount_unit
      //     if (total_grand < 0) {
      //       return sum + 0;
      //     }
      //     else {
      //       return sum + (total_grand)
      //     }
      //   }
      // }, 0)
      // return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      let before_vat = 0;
      let total_result = 0;
      let discount_percent = this.po_data.discount_percent;
      let discount_unit = this.po_data.discount_unit;
      let data_list = this.po_list;
      const subTotal = data_list.reduce((sum, number) => {
        return sum + number.total
      }, 0);
      let percent = (parseFloat(subTotal) * discount_percent) / 100;
      let total_percent = parseFloat(subTotal) - percent;
      let total_discount = total_percent - discount_unit;

      if (this.po_data.type_vat == 1) {
        before_vat = total_discount * (7 / 100);
        total_result = total_discount + before_vat;
      } else {
        total_result = total_discount;
      }

      return total_result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  beforeMount() {
    this.getPO_list();
  },
  mounted() {
    this.get_units();
    this.getProductList();
  }
}
</script>

<style scoped>
.text_total {
  font-size: 14px;
}

.border_col {
  border-left: #f1f1f1 solid 2px;
  border-right: #f1f1f1 solid 2px;
}

.discount_input>>>input {
  text-align: end;
}

.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_sidebyside {
  display: grid;
  grid-template-columns: 30% 70%;
}

.input_width {
  width: 100%;
}

.discount_color {
  background-color: rgb(225 248 251);
}

.total_color {
  background-color: #e1ffb8;
}

@media only screen and (max-width: 1100px) {
  .grid_sidebyside {
    display: grid;
    grid-template-columns: 40% 60%;
  }
}

@media only screen and (max-width: 650px) {
  .detail_style {
    padding-left: 60px;
    margin-top: -5px !important;
  }

  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }

  .grid_sidebyside {
    display: grid;
    grid-template-columns: 100%;
  }

  .btn_mobile {
    width: 100%;
  }
}
</style>
